class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    if (window.CabaneCatalogSearch?.handleFilters(searchParams, event, updateURLHash)) return;
    const requestVersion = ++FacetFiltersForm.requestVersion;
    document.querySelector('[data-facet-error]')?.remove();
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event, requestVersion);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event, requestVersion = FacetFiltersForm.requestVersion) {
    return fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('Filter response failed');
        return response.text();
      })
      .then((responseText) => {
        if (requestVersion !== FacetFiltersForm.requestVersion) return;
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      }).catch(() => {
        if (requestVersion !== FacetFiltersForm.requestVersion) return;
        FacetFiltersForm.showError();
      });
  }

  static showError() {
    document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner').forEach(el => el.classList.add('hidden'));
    document.querySelectorAll('#ProductGridContainer .loading, #ProductCount, #ProductCountDesktop').forEach(el => el.classList.remove('loading'));
    FacetFiltersForm.toggleActiveFacets(false);
    const container = document.getElementById('ProductGridContainer');
    if (!container || container.querySelector('[data-facet-error]')) return;
    const message = document.createElement('p');
    message.dataset.facetError = '';
    message.setAttribute('role', 'alert');
    message.textContent = 'Impossible d’actualiser les résultats. Les produits affichés correspondent à la sélection précédente. ';
    const retry = document.createElement('button');
    retry.type = 'button';
    retry.className = 'button button--secondary';
    retry.textContent = 'Réessayer';
    retry.addEventListener('click', () => FacetFiltersForm.renderPage(FacetFiltersForm.searchParamsPrev, null, false));
    message.append(retry);
    container.prepend(message);
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.dataset.cabaneServerCount = container.textContent.trim();
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.dataset.cabaneServerCount = containerDesktop.textContent.trim();
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate && !event.target.closest('price-range')) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    form.querySelectorAll("price-range").forEach(range => {
      range.querySelectorAll('input[type="number"]').forEach(input => range.adjustToValidValues(input));
      range.setMinAndMaxValues();
    });
    const formData = new FormData(form);
    const selection = new URLSearchParams(location.search).get('cabane_selection');
    if (selection && document.querySelector('[data-scooter-choices]')) formData.set('cabane_selection', selection);
    const term = new URLSearchParams(location.search).get('cabane_q');
    if (term && document.querySelector('[data-cabane-collection-search="true"]')) formData.set('cabane_q', term);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.requestVersion = 0;
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  connectedCallback() {
    // AJAX replaces facet contents; initialise each new instance once.
    queueMicrotask(() => this.init());
  }

  init() {
    if (this.ready || !this.isConnected) return;
    this.inputs = [...this.querySelectorAll('input[type="number"]')];
    if (this.inputs.length !== 2) return;
    this.ready = true;
    this.limit = Number(this.dataset.rangeMax || this.inputs[1].max);
    this.handles = [...this.querySelectorAll('[data-price-handle]')];
    this.formatter = new Intl.NumberFormat(this.dataset.locale || document.documentElement.lang, {
      style: 'currency', currency: this.dataset.currency || 'EUR', maximumFractionDigits: 0
    });
    this.inputs.forEach(input => {
      input.addEventListener('change', () => {
        this.adjustToValidValues(input);
        this.setMinAndMaxValues();
      });
      input.addEventListener('input', () => this.syncSlider());
    });
    this.handles.forEach((handle, index) => {
      handle.disabled = this.limit <= 0;
      handle.addEventListener('input', event => {
        // Do not replace the product grid while a finger is still dragging.
        event.stopPropagation();
        const other = Number(this.handles[1 - index].value);
        const value = index === 0 ? Math.min(Number(handle.value), other) : Math.max(Number(handle.value), other);
        handle.value = String(value);
        this.inputs[index].value = value === (index === 0 ? 0 : this.limit) ? '' : String(value);
        this.setMinAndMaxValues();
      });
      handle.addEventListener('change', () => this.commit());
    });
    this.querySelector('[data-price-reset]')?.addEventListener('click', () => {
      this.inputs.forEach(input => { input.value = ''; });
      this.setMinAndMaxValues();
      this.commit();
    });
    this.querySelector('.cabane-price-exact')?.removeAttribute('open');
    const slider = this.querySelector('.cabane-price-slider');
    if (slider) slider.hidden = false;
    this.setMinAndMaxValues();
  }

  commit() {
    this.inputs[0].dispatchEvent(new Event('input', { bubbles: true }));
  }

  setMinAndMaxValues() {
    const [minInput, maxInput] = this.inputs || this.querySelectorAll('input[type="number"]');
    if (!minInput || !maxInput) return;
    minInput.max = maxInput.value || String(this.limit);
    maxInput.min = minInput.value || '0';
    this.syncSlider();
  }

  adjustToValidValues(input) {
    if (input.type !== 'number' || input.value === '') return;
    const number = Number(input.value);
    if (!Number.isFinite(number)) return;
    const value = input.name.endsWith('.lte') ? Math.ceil(number) : Math.floor(number);
    input.value = String(Math.max(Number(input.min), Math.min(Number(input.max), value)));
  }

  syncSlider() {
    if (!this.handles?.length) return;
    const low = Math.max(0, Math.min(this.limit, Number(this.inputs[0].value || 0)));
    const high = Math.max(low, Math.min(this.limit, Number(this.inputs[1].value || this.limit)));
    this.handles[0].value = String(low);
    this.handles[1].value = String(high);
    this.handles[0].setAttribute('aria-valuemax', String(high));
    this.handles[1].setAttribute('aria-valuemin', String(low));
    [low, high].forEach((value, index) => this.handles[index].setAttribute('aria-valuetext', this.formatter.format(value)));
    this.querySelector('[data-price-from]').textContent = this.formatter.format(low);
    this.querySelector('[data-price-to]').textContent = this.formatter.format(high);
    this.style.setProperty('--price-from', `${this.limit ? low / this.limit * 100 : 0}%`);
    this.style.setProperty('--price-to', `${this.limit ? high / this.limit * 100 : 100}%`);
    // Both ends remain reachable when the handles coincide at either edge.
    this.handles[0].style.zIndex = low >= this.limit ? '3' : '1';
    const reset = this.querySelector('[data-price-reset]');
    if (reset) reset.disabled = this.inputs.every(input => input.value === '');
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

